export interface ErrorResponseData {
  detail: string;
  status: number;
  title: string;
  type: string;
}

export class Status {
  //#region Application
  getApplicationLoading: boolean = false;
  createApplicationLoading: boolean = false;
  updateApplicationLoading: boolean = false;
  deleteApplicationLoading: boolean = false;
  applicationErrorMsg: string = '';
  //#endregion

  //#region Benutzer
  getBenutzerLoading: boolean = false;
  createBenutzerLoading: boolean = false;
  updateBenutzerLoading: boolean = false;
  deleteBenutzerLoading: boolean = false;
  benutzerErrorMsg: string = '';
  //#endregion

  //#region Unternehmen
  getUnternehmenLoading: boolean = false;
  checkUnternehmenRealmLoading: boolean = false;
  createUnternehmenLoading: boolean = false;
  updateUnternehmenLoading: boolean = false;
  deleteUnternehmenLoading: boolean = false;
  unternehmenErrorMsg: string = '';
  //#endregion

  //#region Unternehmen Users
  getUnternehmenUsersLoading: boolean = false;
  unternehmenUserErrorMsg: string = '';

  getAllArchivUserLoading: boolean = false;
  updateArchivUserLoading: boolean = false;
  archivUserErrorMsg: string = '';
  //#endregion
}
